const s3_cdn_homolog = 'testweb-serrano';

const Vlance_s3 = 's3-sa-east-1.amazonaws.com';

const vlance_s3_cdn = '906de634c48fb7d34136160b4c353ae4';

var vlanceS3 = (process.env.VUE_APP_NODE_ENV === 'development' || process.env.VUE_APP_NODE_ENV === 'homologacao') ? s3_cdn_homolog : vlance_s3_cdn;

var caminho = process.env.VUE_APP_NODE_ENV === 'development' ? process.env.VUE_APP_URL_API : location.protocol + "//" + window.location.hostname;

export default class mapaDeRotas {
    constructor(
        rota_api = `${caminho}`,
        rota_procuracao = `${process.env.VUE_APP_URL_PROCURACAO_S3}`,
        rota_api_sms_cod = `${process.env.VUE_APP_URL_SMS_CODE_VALIDA}`,
        rota_api_sms_cod_reenvia = `${process.env.VUE_APP_URL_SMS_CODE_REENVIA}`,
    ) {
        this.rota_docs_s3 = `https://${Vlance_s3}/${vlanceS3}`;
        this.rota_api = rota_api;
        this.rota_procuracao = rota_procuracao;
        this.rota_api_sms_cod = rota_api_sms_cod;
        this.rota_api_sms_cod_reenvia = rota_api_sms_cod_reenvia;
    }
}
